import _ from 'lodash';
import moment from 'moment-timezone';

export function transformString(inputString, randomLength = 2, join) {
    // Convert to snake_case
    let snakeCaseStr = _.snakeCase(inputString);

    // Remove numbers
    snakeCaseStr = snakeCaseStr.replace(/\d+/g, '');

    // Generate random characters
    const characters = 'abcdefghijklmnopqrstuvwxyz';
    const randomChars = Array.from({ length: randomLength }, () =>
        characters.charAt(Math.floor(Math.random() * characters.length)),
    ).join('');

    // Combine and return
    return snakeCaseStr + (join || '_') + randomChars;
}

export const formatFormToWhatsappFlow = (screens) => {
    let formScreens = screens.map((s) => ({ ...s, id: transformString(s.title, 4, '_') }));
    const transformedScreens = [];
    let variablesData = [];
    if (formScreens.length > 0) {
        for (let i = 0; i < formScreens.length; i++) {
            let screen = formScreens[i];
            let children = [];

            for (let j = 0; j < screen?.components?.length; j++) {
                let component = screen.components[j];
                delete component.id;
                const componentName = transformString(component.label, 4, '-');
                switch (component.type) {
                    case 'TextHeading':
                    case 'TextSubheading':
                    case 'TextBody':
                    case 'TextCaption':
                        children.push(component);
                        break;
                    case 'TextInput':
                        children.push({
                            ...component,
                            name: componentName,
                        });
                        variablesData.push({
                            name: componentName,
                            type: component.type,
                            screenId: screen.id,
                            data: {
                                type: 'string',
                                __example__: component.label,
                            },
                        });
                        break;
                    case 'TextArea':
                        children.push({
                            ...component,
                            name: componentName,
                        });
                        variablesData.push({
                            name: componentName,
                            type: component.type,
                            screenId: screen.id,
                            data: {
                                type: 'string',
                                __example__: component.label,
                            },
                        });
                        break;
                    case 'DatePicker':
                        children.push({
                            ...component,
                            name: componentName,
                            type: component.type,
                        });
                        variablesData.push({
                            name: componentName,
                            type: component.type,
                            screenId: screen.id,
                            data: {
                                type: 'string',
                                __example__: moment().format('YYYY-MM-DD'),
                            },
                        });
                        break;
                    case 'RadioButtonsGroup':
                    case 'CheckboxGroup':
                    case 'Dropdown':
                        children.push({
                            ...component,
                            name: componentName,
                        });
                        variablesData.push({
                            name: componentName,
                            type: component.type,
                            screenId: screen.id,
                            data: {
                                type: 'string',
                                __example__: component['data-source'][0].title,
                            },
                        });
                        break;
                    case 'OptIn':
                        children.push({
                            ...component,
                            name: componentName,
                        });
                        variablesData.push({
                            name: componentName,
                            type: component.type,
                            screenId: screen.id,
                            data: {
                                type: 'boolean',
                                __example__: false,
                            },
                        });
                        break;
                    case 'Image':
                        children.push({
                            ...component,
                            src: component.src.split(',')[1],
                        });
                        break;
                    default:
                        break;
                }
            }

            let transformedScreen = {
                title: screen.title,
                id: screen.id,
                data: {},
                terminal: i === formScreens.length - 1,
                layout: {
                    type: 'SingleColumnLayout',
                    children: [
                        {
                            type: 'Form',
                            name: 'flow_path',
                            children,
                        },
                    ],
                },
                footerButton: screen.footerButton,
            };
            transformedScreens.push(transformedScreen);
        }
    }
    for (let i = 0; i < transformedScreens.length; i++) {
        const currentScreen = transformedScreens[i];
        // Last screen payload
        if (variablesData.length > 0 && i > 0) {
            const data = {};
            variablesData.forEach((v) => {
                data[v.name] = v.data;
            });
            currentScreen.data = data;
        }

        const payload = {};
        variablesData.forEach((v) => {
            if (currentScreen.id === v.screenId) {
                payload[v.name] = `\${form.${v.name}}`;
            } else {
                const screenIndex = transformedScreens.findIndex((s) => s.id === v.screenId);
                if (screenIndex < i) {
                    payload[v.name] = `\${data.${v.name}}`;
                } else {
                    if (v.type === 'boolean') {
                        payload[v.name] = false;
                    } else {
                        payload[v.name] = '';
                    }
                }
            }
        });
        if (i === transformedScreens.length - 1) {
            currentScreen.layout.children[0].children.push({
                type: 'Footer',
                label: currentScreen.footerButton.label,
                'on-click-action': {
                    name: 'complete',
                    payload,
                },
            });
        } else if (i < transformedScreens.length - 1) {
            const nextScreenId = transformedScreens[i + 1].id;
            currentScreen.layout.children[0].children.push({
                type: 'Footer',
                label: currentScreen.footerButton.label,
                'on-click-action': {
                    name: 'navigate',
                    payload,
                    next: {
                        type: 'screen',
                        name: nextScreenId,
                    },
                },
            });
        }
        delete currentScreen.footerButton;
    }
    return {
        version: '6.0',
        screens: transformedScreens,
    };
};
